<script setup lang="ts">
interface Props {
  to: string | undefined
}

const props = defineProps<Props>()
</script>

<template>
  <a :href="props.to">
    <slot />
  </a>
</template>
